export default __webpack_public_path__ + "static/media/b62.b3b9e571.png";